import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ParseService } from '../../../../shared/common/parse/parse.service';
import { QueryInterface } from '../../../../shared/common/parse/query-interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { LazyLoadEvent } from 'primeng/primeng';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})

export class ClientListComponent implements OnInit {

  totalRecords: number;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  firstname: String;
  lastname: String;
  public paginationNumberFormatter;
  value: any;
  public paginationPageSize;
  rowData = [];
  cols: any[];
  private gridApi;
  companyDetailsForm: FormGroup;
  contactDetailsForm: FormGroup;
  tenantId: '';

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private _location: Location,
    private formBuilder: FormBuilder,
    private storageConfiguration: StorageConfiguration
  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'Company name', field: 'companyName', cellStyle: { color: '#049ae5', cursor: 'pointer' } },
      { header: 'First name', field: 'firstName' },
      { header: 'Last name', field: 'lastName' },
      { header: 'Email', field: 'emailAddress' },
      { header: 'Phone number', field: 'companyPhoneNo' }
    ];
  }

  async ngOnInit() {
    // this.getClients();
    // COMPANY DETAILS VALIDATION
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.companyDetailsForm = this.formBuilder.group({
      companyName: ['', Validators.required],
      companyAddress: ['', Validators.required],
      city: ['', Validators.email],
      state: ['', Validators.email],
      country: ['', Validators.required],
      mobileno: ['', Validators.required],
      emailAddress: ['', Validators.required],
      currency: ['', Validators.required]
    });

    this.contactDetailsForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      preferredContactTime: ['', Validators.required],
      timeZone: ['', Validators.email],
      websiteurl: ['', Validators.required],
      facebookurl: ['', Validators.required],
      twitterurl: ['', Validators.required],
      skypeurl: ['', Validators.email]
    });
  }

  /* 
  ** ==========================================================
  **  Get Client List Function
  ** ==========================================================
  */

  async getClients() {
    this.totalRecords = await this.getResourcesCount();
    this.queryInterface.executeQuery(this.parseService, 'Client', [{ condition: 'limit', value: 10 },
    { condition: 'equalTo', field: 'tenantId', value: this.tenantId },]).then(async results => {
      this.rowData = this.loadResources(results, 0);
    });
  }

  loadResources(results, skip) {
    let result = [];
    let i = skip;
    results.forEach(element => {
      i = i + 1;
      let companyInfo = element.get('companyInfo');
      result.push({
        position: i,
        companyName: companyInfo ? companyInfo.companyName : '',
        firstName: companyInfo ? companyInfo.firstName : '',
        lastName: companyInfo ? companyInfo.lastName : '',
        emailAddress: companyInfo ? companyInfo.emailAddress : '',
        companyPhoneNo: companyInfo.companyPhoneNo.number ? companyInfo.companyPhoneNo.number : companyInfo.companyPhoneNo,
        objectId: element.id
      });
    });
    return result;
  }

  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */

  async onLazyLoadResources(event: LazyLoadEvent) {
    this.loadEventData = event;
    let condition = [];
    condition.push({ condition: 'equalTo', field: 'tenantId', value: this.tenantId });
    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      condition.push({ condition: 'skip', value: event.first });
      this.totalRecords = await this.getTotalRecordCount(condition);
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else if (event.sortField) {
      const skip: number = event.first;
      let field = event.sortField;
      let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let filterValue = filter[key].value;
        if (!(filterValue.length < 1)) {
          if (key != 'companyInfo.emailAddress') {
            filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
          }
          condition.push({ condition: 'contains', field: key, value: filterValue });
        }
      }
      let sortCondition = {};
      if (sortOrder == 'ascending') {
        sortCondition = { condition: sortOrder, value: field };
      } else {
        sortCondition = { condition: sortOrder, field: field };
      }
      condition.push(
        sortCondition,
        { condition: 'skip', value: event.first });
      this.totalRecords = await this.getTotalRecordCount(condition);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else {
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let filterValue = filter[key].value;
        if (!(filterValue.length < 1)) {
          if (key != 'companyInfo.emailAddress') {
            filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
          }
          condition.push({ condition: 'contains', field: key, value: filterValue });
        }
      }
      condition.push({ condition: 'skip', value: event.first });
      this.totalRecords = await this.getTotalRecordCount(condition);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, event.first, event.rows);
    }
  }

  lazyLoadAddResources(condition, skip, limit) {
    condition.push({ condition: 'limit', value: limit });
    this.queryInterface.executeQuery(this.parseService, 'Client', condition).then(results => {
      this.rowData = this.loadResources(results, skip);
    });
  }

  /*
  ** ==========================================================
  ** Get total records
  ** ==========================================================
  */
  getTotalRecordCount(condition) {
    return this.queryInterface.getQueryCount(this.parseService, 'Client', condition);
  }

  getResourcesCount() {
    return this.queryInterface.getQueryCount(this.parseService, 'Client', [{ condition: 'ascending', value: 'companyName' }, { condition: "equalTo", field: "tenantId", value: this.tenantId }]);
  }

  nameClick(events) {
    this.router.navigate(['client-create', { id: events }]);
  }

  backlocation() {
    this._location.back();
  }

  onPageSizeChanged() {
    var value = (<HTMLInputElement>document.getElementById('page-size')).value;
    this.gridApi.paginationSetPageSize(Number(value));
  }

  clientCreate() {
    this.router.navigate(['client-create']);
  }

}
